// extracted by mini-css-extract-plugin
export default {"hello-text":"hello-text--mgM1u","helloText":"hello-text--mgM1u","highlight":"highlight--vuaNG"};